let paramsFromSearchQuery = (searchQuery: string): Record<string, any> => {
  // Instead of manually parsing, we can use URLSearchParams
  const searchParams = new URLSearchParams(searchQuery);
  
  let builtQuery: Record<string, any> = {};
  searchParams.forEach((value, key) => {
    if (value === "") return;
    
    if (key === "filters") {
      builtQuery[key] = decodeURIComponent(value);
    } else {
      builtQuery[key] = value;
    }
  });

  return builtQuery;
}

/**
 * Convert an object to a URL search params string
 * Replacement for QueryString.stringify
 */
let objectToURLSearchParams = (obj: Record<string, any>): string => {
  let urlSearchParams = new URLSearchParams()
  Object.entries(obj).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((arrValue) => {
        urlSearchParams.append(key, arrValue)
      })
    } else if (value !== undefined && value !== null) {
      urlSearchParams.append(key, value)
    }
  });
  return urlSearchParams.toString();
}

let searchQueryFromParams = (page: number, limit: number, order: string, filters: Object, search: string ) => {
  let params: Record<string, any> = {
    page,
    limit,
    order,
    search,
    filters: JSON.stringify(filters) as string
  }

  // Remove undefined values
  Object.keys(params).forEach(key => {
    if (params[key] === null) {
      delete params[key]
    }
  })

  // Use URLSearchParams instead of QueryString
  return objectToURLSearchParams(params)
}

export { paramsFromSearchQuery, objectToURLSearchParams }